import { render, staticRenderFns } from "./BoxLoading.vue?vue&type=template&id=f081aabe&scoped=true"
import script from "./BoxLoading.vue?vue&type=script&lang=js"
export * from "./BoxLoading.vue?vue&type=script&lang=js"
import style0 from "./BoxLoading.vue?vue&type=style&index=0&id=f081aabe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f081aabe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f081aabe')) {
      api.createRecord('f081aabe', component.options)
    } else {
      api.reload('f081aabe', component.options)
    }
    module.hot.accept("./BoxLoading.vue?vue&type=template&id=f081aabe&scoped=true", function () {
      api.rerender('f081aabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BoxLoading.vue"
export default component.exports